import React, { useState, useEffect } from 'react';
import SearchHeader from './SearchHeader';
import SearchTabs from './SearchTabs';
import PopularSearches from './PopularSearches';
import RelatedSearches from './RelatedSearches';
import PostTypeResult from '../ResultTypes/PostTypeResult';
import ArchiveTypeResult from '../ResultTypes/ArchiveTypeResult';
import ProductTypeResult from '../ResultTypes/ProductTypeResult';
import SpinnerSVG from '../../../../svgs/spinner.svg';
import DatabaseWrapper from '../Database/DatabaseWrapper';

const SearchResults = props => {
    const [posts, setPosts] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [country, setCountry] = useState(props.country ? props.country : 'GB');
    const [currency, setCurrency] = useState(props.currency ? props.currency : 'GBP');
    const [userGeoData, setUserGeoData] = useState(props.userGeoData
        ? props.userGeoData
        : {
            country: 'GB',
            currency: 'GBP',
            locale: 'en-GB',
        }
    );

    const getResults = () => {
        if (posts) {
            const results = posts;

            if (results.total.value === 0) {
                return <h6 style={{ margin: '30px auto' }}>Sorry there are no results for that search</h6>;
            }

            return Object.values(results.hits).map((data, index) => {
                switch (data._source.postType) {
                    case 'post':
                        return <PostTypeResult item={data._source} key={index} />;
                    case 'issue_content':
                        return <ArchiveTypeResult item={data._source} key={index} />;
                    case 'product':
                        return <ProductTypeResult
                            item={data._source}
                            key={index}
                            country={country}
                            currency={currency}
                            userGeoData={userGeoData}
                            dispatchEvent={true}
                        />
                    default:
                        return <PostTypeResult item={data._source} key={index} />;
                }
            });
        }
    };

    const Results = ( props ) => {

        if (props.posts) {
            if (props.type.includes('database')) {
                return <DatabaseWrapper term={props.term} results={props.posts.hits} />
            } else {
                return <div className="search-listing">{getResults()}</div>
            }
        } else {
            return null;
        }

    }

    const ViewAll = ( props ) => {
        return (
            <>
                { props.tabType === 'podcast' || props.tabType === 'video' ? (
                    <a href={'/?s=' + props.term + '&tax=' + props.tabType } className="button button--outline">
                        View All
                    </a>
                ) : (
                    <>
                    { props.tabType === 'post' ? (
                        <a href={'/?s=' + props.term } className="button button--outline">
                            View All
                        </a>
                    ) : (
                        <a href={'/?s=' + props.term + '&type=' + props.tabType } className="button button--outline">
                            View All
                        </a>
                    ) }
                    </>
                ) }
            </>
        )
    }

    useEffect(() => {
        if (props.results) {
            setPosts(props.results.results);
        }
    }, [props.results]);

    return (
        <>
            {props.results ? (
    
                <>
                    {/* {props.results.totalResultCount > 0 ? <RelatedSearches {...props} /> : null} */}

                    {props.results.totalResultCount > 0 && props.term.length > 0 ? (
                        <>
                            <SearchHeader {...props} />
                            <SearchTabs {...props} />
                            <Results type={props.type} posts={posts} term={props.term}/>
                            <div className="search-listing-footer">
                                {isLoading ? (
                                    <a className="button button--outline loading-button">
                                        Searching
                                        <span
                                            className="loading-button__icon"
                                            style={{ backgroundImage: `url(${SpinnerSVG})` }}></span>
                                    </a>
                                ) : (
                                    <ViewAll tabType={props.tabType} term={props.term}/>
                                )}
                            </div>
                        </>
                    ) : (
                        <PopularSearches {...props} />
                    )}
                </>
                
            ) : (
                <PopularSearches {...props} />
            )}


        </>
    );
};

export default SearchResults;
